import React from 'react';
import styles from './AlisaTextField.module.scss';
import { fieldNames } from '../../../common/config';
import DispexInput from '../../../../../../../components/DispexInput';
import { typeInput } from '../../../../../../../components/DispexInput';
import { Form, Icon, Tooltip } from 'antd';
import { useAlisaAudioManagerState } from '../../../../../shared/lib/alisaAudioManager';
import Actions from './Actions/Actions';

const placeholder = `(Пишите лаконично. Несколько отключений произносятся поочередно) 
По вашему адресу отключено электричество до 16:00 3 сентября`;

const alisaTextFieldName = fieldNames.alisaText;
const enableAlisaFieldName = fieldNames.enableAlisa;
const FormItem = Form.Item;

const AlisaTextField = ({ form }) => {
  const enableAlisaValue = form.getFieldValue(enableAlisaFieldName);

  const playingShutdownId = useAlisaAudioManagerState();

  return (
    <>
      <FormItem
        style={{ margin: 0 }}
        label={
          <span>
            Текст автоответа&nbsp;
            <Tooltip title="При звонке в аварийно-диспетчерскую службу активируется автоинформатор с текстом автоответа">
              <Icon
                type="info-circle"
                style={{ fontSize: '16px' }}
              />
            </Tooltip>
            &nbsp;
            <span className={styles.accentLabel}>
              Проигрывается после приветствия, если оно подключено
            </span>
          </span>
        }
      >
        {form.getFieldDecorator(alisaTextFieldName, {
          rules: [
            {
              required:
                typeof enableAlisaValue === 'boolean'
                  ? enableAlisaValue
                  : false,
              message: 'Введите текст автоответ',
            },
          ],
        })(
          <DispexInput
            typeInput={typeInput.textarea}
            placeholder={placeholder}
            disabled={Boolean(playingShutdownId)}
          />
        )}
      </FormItem>
      <div className={styles.actions}>
        <Actions form={form} />
      </div>
    </>
  );
};

export default AlisaTextField;
